export default class formConfig {
  // 企业登记信息-详情
  static configList() {
    return [
      {
        title: "招标对投标人要求",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "requirementList",
            class: "formList",
          },
        ]
      },
      {
        title: "投标人能力及信誉要求",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "投标人能力及信誉要求：",
            value: "abilityReputation",
            type: "textarea",
            width: "100%;",
            maxlength: 1200,
            tip: "（最多可填1200个汉字）",
            disabled: false
          }
        ]
      },
    ];
  }
}
